export default __webpack_public_path__ + "static/media/vision.eec81f94.svg";